<template>
  <div class="notarization-progress">
    <div class="content-top clearfix">
      当前位置：
      <span @click="goDataList">
        {{
          notaryBusinessId == 2 || notaryBusinessId == 3
            ? "贷款赋强公证"
            : "调解赋强公证"
        }}
        - 公证详情</span
      >
    </div>
    <div class="content-main">
      <div class="progress-con">
        <!-- 申请信息 -->
        <div class="progress-con1">
          <div class="pro-con-details">
            <div class="details-title">公证详情</div>
            <div class="apply-contact-info">
              <p>
                <label>申请公证名称：</label>
                <span
                  >《{{
                    notarization.notarizationName && notarization.notarizationName.split(".")[0] || "-"
                  }}》</span
                >
              </p>
              <p>
                <label>公证编码：</label>
                <span>{{ notarization.evidenceCode || "-" }}</span>
              </p>
              <p>
                <label>公证处：</label>
                <span>{{ notarization.notarial || "-" }}</span>
              </p>
              <p>
                <label>申请人：</label>
                <span>{{ notarization.userRegisterName || "-" }}</span>
              </p>
              <p>
                <label>公证书类型：</label>
                <span v-if="notarization.notaryDocType == 3"
                  >电子公证书和纸质公证书</span
                >
                <span v-else-if="notarization.notaryDocType == 2"
                  >纸质公证书</span
                >
                <span v-else-if="notarization.notaryDocType == 1"
                  >电子公证书</span
                >
                <span v-else> -</span>
              </p>
              <p v-if="notarization.notaryDocType != 1">
                <label>领取方式：</label>
                <span v-if="notarization.usingEMS">邮寄</span>
                <span v-if="!notarization.usingEMS">线下领取</span>
              </p>
              <template
                v-if="!notarization.usingEMS && notarization.notaryDocType != 1"
              >
                <p>
                  <label>领取人：</label>
                  <span
                    v-if="
                      !notarization.usingEMS && notarization.recipientType == 1
                    "
                    >本人领取</span
                  >
                  <span
                    v-else-if="
                      !notarization.usingEMS && notarization.recipientType == 2
                    "
                    >其他自然人领取</span
                  >
                  <span
                    v-else-if="
                      !notarization.usingEMS && notarization.recipientType == 3
                    "
                    >账号使用者领取</span
                  >
                  <span v-else></span>
                </p>
              </template>
              <template v-if="notarization.notaryDocType != 2">
                <p>
                  <label>电子公证书接收手机号：</label>
                  <span>{{ notarization.receiverMobile || "-" }}</span>
                </p>
                <p>
                  <label>电子公证书接收邮箱：</label>
                  <span>{{ notarization.receiverEmail || "-" }}</span>
                </p>
              </template>
              <template v-if="notarization.notaryDocType != 1">
                <p>
                  <label>公证书份数：</label>
                  <span>{{ notarization.pageNum || "-" }}</span>
                </p>

                <template v-if="notarization.usingEMS">
                  <p>
                    <label>收件人：</label>
                    <span>{{ notarization.userRegisterName || "-" }}</span>
                  </p>
                  <p>
                    <label>收件人手机号：</label>
                    <span>{{ notarization.proxyMobile || "-" }}</span>
                  </p>
                  <p>
                    <label>收件地址：</label>
                    <span>{{ notarization.proxyAddress || "-" }}</span>
                  </p>
                  <p>
                    <label>邮政编码：</label>
                    <span>{{ notarization.proxyZipcode || "-" }}</span>
                  </p>
                </template>
                <template
                  v-else-if="
                    !notarization.usingEMS && notarization.recipientType != 1
                  "
                >
                  <p>
                    <label>代领人姓名：</label>
                    <span>{{ notarization.proxyName || "-" }}</span>
                  </p>
                  <p>
                    <label>代领人证件号：</label>
                    <span>{{ notarization.proxyCard || "-" }}</span>
                  </p>
                  <p>
                    <label>代领人手机号：</label>
                    <span>{{ notarization.proxyMobile || "-" }}</span>
                  </p>
                </template>
              </template>
              <p>
                <label>公证事项：</label>
                <span>{{
                  notarization.notarizationType == 1
                    ? "保全证据公证"
                    : $route.query.flag == 4
                    ? "强执公证"
                    : "赋强公证"
                }}</span>
              </p>
              <!-- <p>
                <label>公证书用途：</label>
               <span v-show="notarization.notaryCertificateUse ==1">诉讼或仲裁（仅限于民事诉讼或仲裁）</span>
                <span v-show="notarization.notaryCertificateUse==2">非诉讼</span>
                <span v-show="notarization.notaryCertificateUse==3">其他</span>
              </p> -->

              <p>
                <label>受理日期：</label>
                <span>{{
                  notarization.approvedDate
                    ? getYMH(notarization.approvedDate)
                    : "-"
                }}</span>
              </p>
              <p>
                <label>公证员：</label>
                <span>{{ notarization.internalNotaryName || "-" }}</span>
              </p>
              <p>
                <label>当前状态：</label>
                <span class="waiting" v-if="notarization.status == 1"
                  >等待提交</span
                >
                <span class="failed" v-if="notarization.status == 0"
                  >审核拒绝</span
                >
                <span class="failed" v-if="notarization.status == 6"
                  >等待签署</span
                >
                <span class="waiting" v-if="notarization.status == 3"
                  >等待付费</span
                >
                <span class="waiting" v-if="notarization.status == 4"
                  >等待制证</span
                >
                <span class="finished" v-if="notarization.status == 5"
                  >已公证</span
                >
                <span class="waiting" v-if="notarization.status == 2"
                  >等待审核</span
                >
                <span class="failed" v-if="notarization.status == 8"
                  >申请失败</span
                >
                <span class="waiting" v-if="notarization.status == 7"
                  >他人办理</span
                >
              </p>
            </div>
          </div>
          <div
            class="pro-con-details"
            style="margin-top: 30px"
            v-if="dataList.length"
          >
            <div class="details-title">
              <div>存证文件</div>
              <div v-if="notarization.canReSign"><el-button type="danger" @click="reSign">重新签署</el-button></div>
            </div>
            <div class="apply-contact-info">
              <template v-if="dataList.length">
                <p
                  class="deposit_list"
                  v-for="(item, index) in dataList"
                  :key="index"
                >
                  <label>{{ item.fileName }}</label>
                  <span
                    ><span class="see_deposit" @click="showCer(item)">预览</span
                    ><span @click="downLoadFn(item)" v-if="notarization.status != 7">下载</span></span
                  >
                </p>
              </template>
            </div>
          </div>
          <!-- <div class="submit-box" style="min-height: 30px;">
            <button @click="submitInfo" v-if="compeletHiden">提交申请</button>
          </div> -->
        </div>
        <!-- <div class="submit-box" style="min-height: 30px;" v-if="stepControl.step2Fail">
          <button @click="reUpdate" v-if="stepControl.isRefill">重新填写</button>
        </div> -->
      </div>
    </div>
    <!-- <action-modal v-if="$store.state.actionModal.showActionModal" @selectRes="selectRes"></action-modal> -->
  </div>
</template>

<script scoped>
import commenConst from "../../../../../../lib/const.js";
// import ActionModal from "../../../../../../components/common/ActionModal";
// import PaginationCustomer from "./components/signHome/PaginationCustomer.vue";
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "",
  components: { Dialog },
  data() {
    return {
      user: {},
      isSelf: -1,
      notarizationID: -1,
      notarizationInfo: {},
      compeletHiden: true,
      //公证详情
      notarization: {},
      dataList: [],
      downloadUrl: "",
      notaryBusinessId: "",
    };
  },
  created() {
    this.notaryBusinessId = this.$route.query.notaryBusinessId;
    this.init();
  },
  computed: {
    ...mapState(["currentInfo", "userInfo", "curState"]),
  },
  methods: {
    init() {
      //   this.notarizationID = this.$router.history.current.query.notarizationID;
      this.user = JSON.parse(sessionStorage.getItem("userInfo"));
      //补充要提交的信息
      this.notarization.uid = this.user.currentUserId;
      this.downloadUrl =
        this.$GlobalConfig.lookCeryificateUrl +
        "/webapi/common/v2/downloadExist?";
      this.downloadUrl =
        this.downloadUrl +
        "rightId=" +
        this.$route.query.id +
        "&token=" +
        this.user.token;
      //   this.notarization.id = this.notarizationID;
      //初次数据请求
      this.infoRequest();
      this.SignFileList();
      // this.proxyUserInfo()
    },
    getAdd(time) {
      if (time > 9) {
        return time;
      } else {
        return "0" + time;
      }
    },
    getYMH(dateTime) {
      let newDateTime = new Date(dateTime);
      return (
        newDateTime.getFullYear() +
        "-" +
        this.getAdd(newDateTime.getMonth() + 1) +
        "-" +
        this.getAdd(newDateTime.getDate()) +
        " " +
        this.getAdd(newDateTime.getHours()) +
        ":" +
        this.getAdd(newDateTime.getMinutes()) +
        ":" +
        this.getAdd(newDateTime.getSeconds())
      );
    },
    infoRequest() {
      BaseApi.createRpcToken(
        "/notaryApply/getNotarizationInfo",
        {
          notaryApplyId: this.$route.query.id,
        },
        "get"
      ).then((response) => {
        if (response.code == 200) {
          //status  状态（0审核拒绝1等待提交2等待审核3等待付费4等待制证5已公证）
          let infoObj = response.datas;
          // this.checkStatus = infoObj.status;
          //领取人类型
          if (infoObj.receiptorType == 1) {
            infoObj.receiptorTypeName = "本人领取";
            //本人领取的话更新不需要填写的信息
            this.notarization.receiptor = infoObj.receiptor;
            this.notarization.receiptorIdCard = infoObj.receiptorIdCard;
            this.isSelf = 1; //本人
            infoObj.isSelf = true;
          } else {
            this.isSelf = 0; //他人
            infoObj.receiptorTypeName = "他人领取";
            infoObj.isSelf = false;
          }
          this.notarization.userIdCard = infoObj.userIdCard;
          this.notarization = infoObj;
          //  BaseApi.createRpcToken("/user/v2/getUserRealNameStatue",{
          //       uid: this.user.currentUserId,
          //   }, "get").then(response => {
          //       let data = response.data.data;
          //       this.notarization.receiptor=data.realName;
          //       this.notarization.receiptorIdCard=data.idcardNumber;
          //       this.notarization.receiptorMobile=data.mobile;
          //       this.notarization.receiptorMail=data.mail;
          //       this.notarization.applyMobile=data.mobile;
          //     })
          //    this.notarization.userAddress=this.notarizationInfo.userAddress;
          // } else {
          //   // this.$store.dispatch("showMsgModal", {
          //   //   autoClose: true,
          //   //   info: response.data.message
          //   // });
        }
      });
    },

    // proxyUserInfo(){
    //   BaseApi.createRpcToken(
    //     "/notaryApply/proxyUserInfo",
    //     {
    //       notaryApplyId: this.$route.query.id,
    //     },
    //     "get"
    //   ).then((response) => {console.log(response);})
    // },

    SignFileList() {
      BaseApi.createRpcToken(
        "/notaryApply/getNotarySignFileList",
        {
          notaryApplyId: this.$route.query.id,
        },
        "get"
      ).then((response) => {
        if (response.code == 200) {
          this.dataList = response.datas.evidenceFile;
        }
      });
    },
    goDataList() {
      if (this.$route.query.flag == 4) {
        // 强执公证
        if (this.notaryBusinessId == 3) {
          this.$router.push("/personal/service/loan?flag=execution");
        } else if (this.notaryBusinessId == 8) {
          this.$router.push("/personal/service/conciliation?flag=execution");
        }
      } else {
        if (this.notaryBusinessId == 2) {
          this.$router.push("/personal/service/loan?flag=third");
        } else if (this.notaryBusinessId == 7) {
          this.$router.push("/personal/service/conciliation?flag=third");
        }
      }
    },
    //预览
    showCer(item) {
      //查看存证证据-Dapp
      if (item.type == 2) {
        this.$router.push({
          path: "/personal/serviceHome/writeProcedure/lookFqCeryificate",
          query: {
            id: item.dataRightId,
            type: 1,
            notaryBusinessId: this.notaryBusinessId,
          },
        });
      } else {
        this.$router.push({
          path: "/personal/serviceHome/fqCertificate",
          query: {
            fileId: item.fileId,
            id: item.contractId,
            notartId: this.$route.query.id,
            notaryBusinessId: this.notaryBusinessId,
          },
        });
      }
    },
    downLoadFn(item) {
      if (item.type == 2) {
        //存证下载
        BaseApi.createRpcToken("/notaryApply/downloadDataRight", {
          rightId: item.dataRightId,
        })
          .then((data) => {
            if (data.datas.path) {
              var elemIF = document.createElement("iframe");
              elemIF.setAttribute("id", "startDown");
              elemIF.src = data.datas.path;
              elemIF.style.display = "none";
              if (document.getElementById("startDown")) {
                document.body.removeChild(document.getElementById("startDown"));
              }
              document.body.appendChild(elemIF);
            } else if (data.datas.packageUrl && data.datas.packageUrl.code == 200) {
              var elemIF = document.createElement("iframe");
              elemIF.setAttribute("id", "startDown");
              elemIF.src = data.datas.packageUrl.path;
              elemIF.style.display = "none";
              if (document.getElementById("startDown")) {
                document.body.removeChild(document.getElementById("startDown"));
              }
              document.body.appendChild(elemIF);
              // var a = document.createElement('a');
              // a.setAttribute('href', data.datas.packageUrl.path);
              // a.setAttribute('target', '_blank');
              // a.setAttribute('id', 'startDown');
              // // 防止反复添加
              // if(document.getElementById('startDown')) {
              //   document.body.removeChild(document.getElementById('startDown'));
              // }
              // document.body.appendChild(a);
              // a.click();
            } else if (data.datas.packageUrl && data.datas.packageUrl.code == 20001) {
              this.$message.error(data.datas.packageUrl.message);
            } else {
              this.$message.error(data.message);
            }
          })
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        //签约下载
        BaseApi.createRpcToken("/file/downloadContractFileZip", {
          fileId: item.fileId,
        })
          .then((data) => {
            if (data.datas.zipUrl) {
              try {
                var elemIF = document.createElement("iframe");
                elemIF.src = data.datas.zipUrl;
                elemIF.style.display = "none";
                elemIF.setAttribute("id", "startDown");
                if (document.getElementById("startDown")) {
                  document.body.removeChild(
                    document.getElementById("startDown")
                  );
                }
                document.body.appendChild(elemIF);
              } catch (e) {}
              // window.open(data.datas.zipUrl);
            } else {
              this.$message.error("下载失败");
            }
          })
          .catch(function (e) {
            errorLog(e);
          });
      }

      //  BaseApi.createRpcToken(this.$GlobalConfig.lookCeryificateUrl+"/webapi/common/v2/downloadExist",{
      //        rightId:item.type == 1?item.dataRightId:'',
      //     }, "get")
      // .then(res => {
      //     if (res.data.code==200){
      // var a = document.createElement('a');
      // a.setAttribute('href', this.downloadUrl);
      // // a.setAttribute('target', '_blank');
      // a.setAttribute('id', 'startDown');
      // // 防止反复添加
      // if(document.getElementById('startDown')) {
      // 	document.body.removeChild(document.getElementById('startDown'));
      // }
      // document.body.appendChild(a);
      // a.click();
      // }else if (res.data.code==20001){
      //   this.$store.dispatch("showMsgModal", {
      //     autoClose: true,
      //     info: res.data.message
      //   });
      // }else {
      //   this.$store.dispatch("showMsgModal", {
      //     autoClose: true,
      //     info:res.data.message
      //   });
      // }
      // });
    },
    // 重新签署
    reSign(){
      BaseApi.createRpcToken(
            "/notaryApply/reSign",
            {
              notaryApplyId: this.$route.query.id,
            },
            
          ).then((response) => {
            if (response.code == 200) {
              this.$message.success("操作成功");
              // this.init()
            }
          });
    }
  },
  watch: {
    curState(data) {
      if (this.$route.query.flag == 4) {
        this.$router.replace("/personal/serviceHome?flag=execution");
      } else {
        this.$router.replace("/personal/serviceHome?flag=third");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@assets/scss/base.scss";
.ell {
  width: 660px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}
button {
  font-size: 14px !important;
}
.errorTips {
  color: $reminder-text;
  float: left;
  margin-left: 6px;
}
.notarization-progress {
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
}
/*位置*/
.content-top {
  height: 52px;
  background: url(../../../../../../assets/images/judicial/pos.png) no-repeat;
  font-size: 16px;
  background-size: 3px 16px;
  background-position: 0 24px;
  box-sizing: border-box;
  padding-left: 13px;
  padding-top: 21px;
}
.content-top span {
  cursor: pointer;
  color: $reminder-text;
}
/*主要区域*/
.content-main {
  border-top: 1px solid #dbdbdb;
  padding-top: 20px;
}
.progress-current {
  width: 560px;
  margin: 24px auto 14px;
}
.progress-current img {
  height: 34px;
}
.progress-current .progress-current-info {
  color: #989898;
  height: 50px;
  line-height: 50px;
}
.progress-current .progress-current-info li {
  float: left;
  width: 140px;
  text-align: center;
}
.progress-con {
  width: 830px;
  margin: 0 auto;
  margin-bottom: 18px;
}
/*步骤*/
.step-box {
  width: 559px;
  height: 34px;
  position: relative;
  //   background: url(../../../../../../assets/images/judicial/pro1.png) no-repeat;
}
.step-subbox {
  width: 145px;
  height: 34px;
  position: absolute;
  height: 100%;
}
.step-subbox img {
  position: relative;
  z-index: 2;
  margin: 0 auto;
}
.step-step1 {
  left: 0%;
}
.step-step2 {
  left: 24.3%;
}
.step-step3 {
  left: 49.3%;
}
.step-step4 {
  left: 73.3%;
}
.step-box .step-line {
  width: 145px;
  height: 4px;
  background-color: $reminder-border;
  overflow: hidden;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 42%;
  /*top:40%;*/
}
.step-step4 {
  width: 149px;
}
.step-box .step-line {
  width: 149px;
}
/*common start*/
.pro-con-details {
  margin: 0 auto;
  border: 1px solid #e4e4e4;
  /*border-radius: 4px;*/
  background-color: #f9f9f9;
  padding: 0 15px;
  color: #464646;
}
.details-title {
  height: 46px;
  padding-top: 15px;
  border-bottom: 1px solid #e4e4e4;
  background: url(../../../../../../assets/images/judicial/arrow.png) no-repeat;
  background-position: 0 31px;
  padding-left: 21px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/*common end*/
/*----------------申请信息---------------*/
.apply-contact-info {
  /*padding-left: 22px;*/
  margin-bottom: 15px;
}
.apply-contact-info > p {
  line-height: 30px;
  margin-top: 13px !important;
}
.apply-contact-info > p > label {
  display: inline-block;
  /*text-align:justify;
	text-align-last: justify;*/
  text-align: right;
  width: 260px;
  margin-right: 15px;
  float: left;
}
.apply-contact-info > p > span {
  word-break: break-all;
  width: 520px;
  display: inline-block;
}
.apply-contact-info > p > input {
  height: 32px;
  width: 310px;
  border: 1px solid #e4e4e4;
  float: left;
  padding-left: 8px;
}
.submit-box {
  text-align: center;
}
.submit-box button {
  margin: 23px auto 29px;
  background: #f5f5f5;
  width: 240px;
  height: 44px;
  line-height: 44px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  color: #464646;
  font-size: 14px;
}
.submit-box button:hover {
  background-color: $reminder-border;
  color: #fff;
  border: 1px solid $reminder-border;
}
/*----------------信息审核---------------*/
.check-status {
  width: 742px;
  margin: 30px auto;
  line-height: 1.75;
}
.check-status img {
  margin-top: 10px;
  float: left;
  width: 32px;
  height: 32px;
}
.check-status p.tips-info {
  width: 674px;
  float: right;
}
.check-status p.tips-info span {
  //color: #0066cc;
}
/*----------------支付费用---------------*/
.table {
  margin-top: 40px;
  margin-bottom: 26px;
}
.tr-header th {
  font-weight: 100;
}
.sum-money {
  text-align: right;
  height: 24px;
  line-height: 24px;
  margin-bottom: 27px;
}
.sum-money span {
  color: $reminder-text;
  font-size: 20px;
}
.sum-money span i {
  font-style: normal;
}
.pay-submit {
  text-align: center;
}
.pay-submit button {
  margin: 23px auto 29px;
  background: #f5f5f5;
  width: 172px;
  height: 44px;
  line-height: 44px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  color: #464646;
}
.pay-submit button:hover {
  background-color: $reminder-border;
  color: #fff;
  border: 1px solid $reminder-border;
}
/*----------------预约取证---------------*/
.progress-con1 {
  padding: 20px 0px;
}
.wait-certificate {
  margin-bottom: 40px;
}
.get-title {
  padding-left: 26px;
  height: 60px;
  line-height: 60px;
}
.get-item {
  padding-left: 127px;
  line-height: 1.75;
}
.get-item label {
  display: inline-block;
  text-align-last: justify;
  width: 96px;
}

.waiting {
  color: #f6a11b;
}

.failed {
  color: $reminder-text;
}

.finished {
  color: #38da12;
}
.deposit_list {
  width: 100%;
  display: flex;
  height: 34px;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: distribute;
  justify-content: space-between;
  margin-top: 13px !important;
  label {
    width: 350px !important;
  }
  span {
    color: rgb(9, 113, 231);
    cursor: pointer;
  }
  .see_deposit {
    display: inline-block;
    margin-right: 5px;
  }
}
::v-deep {
  .el-button--danger {
    background-color: #d81212;
    border-color: #d81212;
  }
}
</style>
